import script from "./ResourcesPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResourcesPage.vue?vue&type=script&lang=ts&setup=true"

import "./ResourcesPage.vue?vue&type=style&index=0&id=2deb7d98&lang=scss"

const __exports__ = script;

export default __exports__